import debounce from 'lodash-es/debounce';
import checkForKeywords from 'owa-calendar-charm-suggestions-store/lib/utils/checkForKeywords';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import getQuickComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getQuickComposeViewState';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import resetCharmSuggestionsHighlightedIndex from 'owa-calendar-charm-suggestions-store/lib/actions/resetCharmSuggestionsHighlightedIndex';
import {
    CharmSelectionType,
    ComposeFormType,
    FULL_COMPOSE_FORM_TYPE,
    QUICK_COMPOSE_FORM_TYPE,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import {
    dismissCharmSuggestions,
    showCharmSuggestions,
} from 'owa-calendar-charm-suggestions-store/lib/actions/charmSuggestionActions';
import { orchestrator } from 'satcheljs';
import {
    onSubjectChanged,
    updateCharm,
    updateSubject,
    onAutomaticCharmChanged,
} from 'owa-calendar-compose-form-actions';

export default orchestrator(onSubjectChanged, actionMessage => {
    let openedForm = getComposeStore().openedForm;
    let newSubject = actionMessage.subject;
    updateSubject(newSubject);

    // debounce setCharmOrShowSuggestions, otherwise we see a lag in typing of the title
    deBouncedSetCharmOrShowSuggestions(openedForm, newSubject);
});

export let deBouncedSetCharmOrShowSuggestions = debounce(
    (openedForm, newSubject) => setCharmOrShowSuggestions(newSubject, openedForm),
    250
);

/**
 * Do processing of the subject and either set the charm or show the charm suggestions
 */
export function setCharmOrShowSuggestions(newSubject: string, openedForm: ComposeFormType) {
    if (openedForm == FULL_COMPOSE_FORM_TYPE) {
        // TODO: WI:28099 When full compose is moved to using CharmSelectionType and implements charm suggestions the code for setting the subject will be the same
        // and this code can be reduced by one half
        let viewState = getFullComposeViewState();

        // Update charm if the previous one was not an explicit set.
        if (viewState && !viewState.isCharmExplicitlySet) {
            // Each time the user types a letter, the highlighted index should be reset
            resetCharmSuggestionsHighlightedIndex();

            // Scan the subject for charm keywords and set/unset charm based on findings.
            let charm = checkForKeywords(newSubject);
            if (charm) {
                updateCharm(charm.IconId);
                dismissCharmSuggestions();
            } else {
                updateCharm(0);

                // Show charm suggestions if there is only one word
                let isOneWord = newSubject.indexOf(' ') <= 0;
                if (newSubject && isOneWord) {
                    showCharmSuggestions();
                } else {
                    dismissCharmSuggestions();
                }
            }
        }
    } else if (openedForm == QUICK_COMPOSE_FORM_TYPE) {
        const quickComposeViewState = getQuickComposeViewState();
        if (!quickComposeViewState) {
            return;
        }

        onAutomaticCharmChanged(newSubject);

        // Each time the user types a letter, the highlighted index should be reset
        resetCharmSuggestionsHighlightedIndex();

        // show the callout only on the first word
        let isOneWord = newSubject.indexOf(' ') <= 0;
        let charmSelectionType = quickComposeViewState.charmSelection;
        if (charmSelectionType == CharmSelectionType.None && isOneWord) {
            showCharmSuggestions();
        } else {
            dismissCharmSuggestions();
        }
    }
}
